import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TableCell,
  TableRow,
} from '@mui/material';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import * as React from 'react';
import { brandColors } from 'brandColors';
import { BlueCargoProperty, UploadedFileColumn } from './types';

interface Props {
  column: UploadedFileColumn;
  onUpdateColumn: (column: UploadedFileColumn) => void;
}

/**
 * TODO: Does this come from the server or is it defined here in the client?
 */
const bluecargoMappingOptions: BlueCargoProperty[] = ['container', 'customer'];

const bluecargoMappings: Record<BlueCargoProperty, { label: string; locked?: boolean }> = {
  container: { label: 'Container', locked: true },
  customer: { label: 'Reference ID' },
};

const cellClassName = 'px-2 py-2';

/**
 * Renders a single row in the column from file mapping table; provides onUpdateColumn callback
 * for manipulating the uploaded file column information and providing it to the parent component.
 */
export const ColumnMappingRow: React.FC<Props> = (props) => {
  const { column, onUpdateColumn } = props;

  const isMapped = column.mapping !== null;

  const handleChange = (event: SelectChangeEvent<BlueCargoProperty | null | ''>) => {
    const property = event.target.value as BlueCargoProperty | null | '';
    onUpdateColumn({ ...column, mapping: property || null });
  };

  const disabled = (column.mapping && bluecargoMappings[column.mapping]?.locked) || false;

  return (
    <TableRow>
      <TableCell className={`border-blue-300 border ${cellClassName}`}>
        <h5 className="truncate">{column.name}</h5>
      </TableCell>
      <TableCell className={cellClassName}>
        <h5 className="truncate">{column.preview || '-'}</h5>
      </TableCell>
      <TableCell className={cellClassName}>
        {isMapped ? (
          <CheckCircleIcon
            style={{
              fontSize: '20px',
              fill: disabled ? brandColors.colors.gray[500] : brandColors.colors.green.DEFAULT,
            }}
          />
        ) : (
          <HighlightOffIcon style={{ fontSize: '20px', fill: brandColors.colors.gray[100] }} />
        )}
      </TableCell>
      <TableCell className={`border-blue-300 border-r ${cellClassName}`}>
        <FormControl size="small" fullWidth>
          <Select
            disabled={disabled}
            value={column.mapping || ''}
            onChange={handleChange}
            displayEmpty
            fullWidth
            style={{ height: '26px', backgroundColor: brandColors.colors.gray[700] }}
          >
            {/* eslint-disable-next-line */}
            {/* @ts-ignore */}
            <MenuItem value="">
              <h5>Not mapped</h5>
            </MenuItem>
            {bluecargoMappingOptions.map((option) => {
              const mapping = bluecargoMappings[option];
              if (!mapping || (mapping.locked && column.mapping !== option)) {
                return null;
              }
              return (
                <MenuItem value={option} key={option}>
                  <h5>{mapping.label}</h5>
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </TableCell>
    </TableRow>
  );
};
ColumnMappingRow.displayName = 'ColumnMappingRow';
